// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDocumentFileUploadByLinkDto
 */
export interface IDocumentFileUploadByLinkDto {
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadByLinkDto
     */
    hash_id: string;
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadByLinkDto
     */
    object_key: string;
    /**
     * 
     * @type {number}
     * @memberof IDocumentFileUploadByLinkDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadByLinkDto
     */
    file_name: string;
}

/**
 * Check if a given object implements the IDocumentFileUploadByLinkDto interface.
 */
export function instanceOfIDocumentFileUploadByLinkDto(value: object): value is IDocumentFileUploadByLinkDto {
    if (!('hash_id' in value) || value['hash_id'] === undefined) return false;
    if (!('object_key' in value) || value['object_key'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    return true;
}

export function IDocumentFileUploadByLinkDtoFromJSON(json: any): IDocumentFileUploadByLinkDto {
    return IDocumentFileUploadByLinkDtoFromJSONTyped(json, false);
}

export function IDocumentFileUploadByLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDocumentFileUploadByLinkDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hash_id': json['hash_id'],
        'object_key': json['object_key'],
        'employee_id': json['employee_id'],
        'file_name': json['file_name'],
    };
}

export function IDocumentFileUploadByLinkDtoToJSON(json: any): IDocumentFileUploadByLinkDto {
    return IDocumentFileUploadByLinkDtoToJSONTyped(json, false);
}

export function IDocumentFileUploadByLinkDtoToJSONTyped(value?: IDocumentFileUploadByLinkDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hash_id': value['hash_id'],
        'object_key': value['object_key'],
        'employee_id': value['employee_id'],
        'file_name': value['file_name'],
    };
}

